/** @license ISC License (c) copyright 2017 original and current authors */
/** @author Ian Hofmann-Hicks (evil) */

var curry = require('../core/curry')

var isSame = require('../core/isSame')

module.exports = curry(isSame)
